export default {
  validate() {
    return true;
  },
};
